import React, { useState } from "react";

import SocialMediaIcons from './social-media-icons'

const MeetFMS = () => {
  const [data, setData] = useState([
    {
      img: "/assets/whyflex/meet1.png",
      title: "Amanda Fisher",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet2.png",
      title: "Amanda Fisher",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet2.png",
      title: "Mike Cannon",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet3.png",
      title: "Erika Gofas",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet1.png",
      title: "Amanda Fisher",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet2.png",
      title: "Amanda Fisher",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet2.png",
      title: "Mike Cannon",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
    {
      img: "/assets/whyflex/meet3.png",
      title: "Erika Gofas",
      subTitle: "Insert your title here",
      desc: "There are many variations of passages of Lorem Ipsum available",
    },
  ]);
  return (
    <div className="text-center mt-20">
      <h2 className="text-btnColor font-popinsBold text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
        Meet the Minds Behind <span className="text-themeColor">FMS</span>
      </h2>
      <div className="flex flex-wrap justify-between w-[90%] mx-auto mt-4 mb-28">
        {data.map((item) => (
          <div key={item.title} className="border border-[#DCDCDC] w-full md:w-[49%] lg:w-[32%] xl:w-[23%] flex flex-col items-center mt-4 px-2 py-6 rounded-md shadow">
            <img src={item.img} alt="" className="size-[150px]"/>
            <h4 className="font-popinsSemiBold text-xl text-textColor mt-4">{item.title}</h4>
            <p className="font-medium font-popinsMedium text-textColor/50 mt-2 text-lg">{item.subTitle}</p>
            <p className="font-medium font-popinsMedium text-textColor/50 mt-3 text-base">{item.desc}</p>
            <SocialMediaIcons/>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetFMS;
